<template>
  <v-app>
    <app-bar @clickBar="toggleNavbar"></app-bar>
    <app-navigation :mini-sidebar="miniSidebar"></app-navigation>
    <v-main>
      <div class="pt-10 pb-10">
        <router-view></router-view>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigation from '@/components/AppNavigation'

export default {
  components: { AppBar, AppNavigation },
  data: () => ({
    miniSidebar: false
  }),
  methods: {
    toggleNavbar () {
      this.miniSidebar = !this.miniSidebar
    }
  }
}
</script>

<style lang="stylus" src="@/assets/styles/main.styl"></style>
